import { useTasks } from './use-tasks';

// Single entry point to the shared active (uncompleted) task subscription.
// Every migrated feeder derives from this one call so TanStack dedupes them all
// onto one Firestore listener — never inline `{ uncompletedOnly: true }` elsewhere.
export const useActiveTasks = () => useTasks({ uncompletedOnly: true });
